module.exports = __webpack_public_path__ + "img/sensor-icon.7733d029.svg";